import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import ar from './locales/ar.json'
// Import translation files
import en from './locales/en.json'
import fr from './locales/fr.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  ar: {
    translation: ar,
  },
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar'], // only support these 3
    nonExplicitSupportedLngs: true, // makes en-US → en, fr-CA → fr, etc.
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    // Support for RTL languages (Arabic)
    react: {
      useSuspense: false,
    },
  })

export default i18n
